/**
 * useAuth
 *
 * Thin accessor hook over AuthContext.
 */
import { useContext } from 'react';
import { AuthContext } from '../context/authContextInstance.js';

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return ctx;
};
